import * as types from './actionTypes';
// import api from 'api/mock';
// import api from '../../../api/mock'
import api from '../../../api/';

export function getData(listicleName) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      const cities = await api.getCities();
      const listicle = await api.getListicle(listicleName);
      // const related = await api.getRelatedStory(story.data.id);
      // const featured = await api.getFeaturedStory('Banglore', 'STORY');
      const related = [];
      const featured = [];
      dispatch({
        type: types.LOADED,
        cities,
        listicle: listicle.data ? listicle.data : {},
        related,
        featured
      });
    }
    catch (error) {
      console.log(error);
    }
  }
}
